import { GlDisclosureDropdown, GlDisclosureDropdownGroup, GlDisclosureDropdownItem, GlDropdownDivider, GlIcon, GlLoadingIcon, GlModal, GlTooltipDirective, GlToggle, GlToastMixin } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { nextTick } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { __, s__, sprintf } from '~/locale';
import { getModifierKey } from '~/constants';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import { keyboardShortcutsDisabled } from '~/behaviors/shortcuts/shortcuts_disabled';
import glFeatureFlagMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import toast from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/plugins/global_toast.js?vue3';
import { isLoggedIn } from '~/lib/utils/common_utils';
import { markAsSpamProjectIssuePath } from '~/lib/utils/path_helpers/issues';
import WorkItemChangeTypeModal from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/work_items/components/work_item_change_type_modal.vue?vue3';
import { CREATION_CONTEXT_RELATED_ITEM, STATE_CLOSED, WORK_ITEM_TYPE_NAME_OBJECTIVE, VIEW_CONTEXT, WIDGET_TYPE_NOTIFICATIONS } from '../constants';
import updateWorkItemMutation from '../graphql/update_work_item.mutation.graphql';
import updateWorkItemNotificationsMutation from '../graphql/update_work_item_notifications.mutation.graphql';
import convertWorkItemMutation from '../graphql/work_item_convert.mutation.graphql';
import namespaceWorkItemTypesQuery from '../graphql/namespace_work_item_types.query.graphql';
import getWorkItemNotificationsByIdQuery from '../graphql/get_work_item_notifications_by_id.query.graphql';
import { findNotificationsWidget, lowercaseWorkItemType } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/utils.js?vue3';
import WorkItemStateToggle from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/work_item_state_toggle.vue?vue3';
import CreateWorkItemModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/create_work_item_modal.vue?vue3';
import MoveWorkItemModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/move_work_item_modal.vue?vue3';
export default {
    name: 'WorkItemActions',
    CREATION_CONTEXT_RELATED_ITEM,
    newRelatedItem: {
        text: s__('WorkItem|New related item')
    },
    promoteItem: {
        text: __('Promote to objective')
    },
    changeTypeItem: {
        text: s__('WorkItem|Change type')
    },
    moveItem: {
        text: __('Move')
    },
    copyReferenceItem: {
        text: __('Copy reference')
    },
    reportAbuseItem: {
        text: __('Report abuse')
    },
    i18n: {
        enableConfidentiality: s__('WorkItem|Turn on confidentiality'),
        disableConfidentiality: s__('WorkItem|Turn off confidentiality'),
        confidentialParentTooltip: s__('WorkItem|Child items of a confidential parent must be confidential. Turn off confidentiality on the parent item first.'),
        notifications: s__('WorkItem|Notifications'),
        notificationOn: s__('WorkItem|Notifications turned on.'),
        notificationOff: s__('WorkItem|Notifications turned off.'),
        referenceCopied: __('Reference copied'),
        emailAddressCopied: __('Email address copied'),
        moreActions: __('More actions')
    },
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlDropdownDivider,
        GlDisclosureDropdownGroup,
        GlIcon,
        GlLoadingIcon,
        GlModal,
        GlToggle,
        WorkItemStateToggle,
        CreateWorkItemModal,
        WorkItemChangeTypeModal,
        MoveWorkItemModal
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glFeatureFlagMixin(),
        Tracking.mixin({
            label: 'actions_menu'
        }),
        GlToastMixin
    ],
    inject: {
        getWorkItemTypeConfiguration: {
            default: ()=>{}
        },
        viewContext: {
            default: VIEW_CONTEXT.fullScreen
        }
    },
    props: {
        fullPath: {
            type: String,
            required: true
        },
        workItemState: {
            type: String,
            required: false,
            default: null
        },
        workItemId: {
            type: String,
            required: false,
            default: null
        },
        workItemIid: {
            type: String,
            required: false,
            default: null
        },
        workItemType: {
            type: String,
            required: false,
            default: null
        },
        projectId: {
            type: String,
            required: false,
            default: null
        },
        canUpdate: {
            type: Boolean,
            required: false,
            default: false
        },
        canUpdateMetadata: {
            type: Boolean,
            required: false,
            default: false
        },
        canDelete: {
            type: Boolean,
            required: false,
            default: false
        },
        canMove: {
            type: Boolean,
            required: false,
            default: false
        },
        canReportSpam: {
            type: Boolean,
            required: false,
            default: false
        },
        isConfidential: {
            type: Boolean,
            required: false,
            default: false
        },
        isDiscussionLocked: {
            type: Boolean,
            required: false,
            default: false
        },
        isParentConfidential: {
            type: Boolean,
            required: false,
            default: false
        },
        workItemReference: {
            type: String,
            required: false,
            default: null
        },
        workItemWebUrl: {
            type: String,
            required: false,
            default: null
        },
        workItemCreateNoteEmail: {
            type: String,
            required: false,
            default: null
        },
        isDetailPanel: {
            type: Boolean,
            required: false,
            default: false
        },
        hideSubscribe: {
            type: Boolean,
            required: false,
            default: false
        },
        hasChildren: {
            type: Boolean,
            required: false,
            default: false
        },
        hasParent: {
            type: Boolean,
            required: false,
            default: false
        },
        parentId: {
            type: String,
            required: false,
            default: null
        },
        workItemAuthorId: {
            type: Number,
            required: false,
            default: 0
        },
        canCreateRelatedItem: {
            type: Boolean,
            required: false,
            default: false
        },
        isGroup: {
            type: Boolean,
            required: true
        },
        widgets: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        features: {
            type: Object,
            required: false,
            default: null
        },
        allowedChildTypes: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        namespaceFullName: {
            type: String,
            required: false,
            default: ''
        },
        showSidebar: {
            type: Boolean,
            required: true
        },
        truncationEnabled: {
            type: Boolean,
            required: true
        },
        updateInProgress: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'delete-work-item',
        'dropdown-show',
        'error',
        'toggle-report-abuse-modal',
        'toggle-sidebar',
        'toggle-truncation-enabled',
        'toggle-work-item-confidentiality',
        'work-item-created',
        'work-item-state-updated',
        'work-item-type-changed'
    ],
    data () {
        return {
            isLockDiscussionUpdating: false,
            isDropdownVisible: false,
            isCreateWorkItemModalVisible: false,
            isMoveWorkItemModalVisible: false,
            workItemTypes: [],
            updateInProgressPromise: null,
            workItemNotificationsSubscribed: false
        };
    },
    apollo: {
        workItemTypes: {
            query: namespaceWorkItemTypesQuery,
            variables () {
                return {
                    fullPath: this.fullPath
                };
            },
            update (data) {
                return data.namespace?.workItemTypes?.nodes;
            },
            skip () {
                return !this.canUpdateMetadata;
            }
        },
        workItemNotificationsSubscribed: {
            query: ()=>{
                return getWorkItemNotificationsByIdQuery;
            },
            variables () {
                return {
                    id: this.workItemId,
                    useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                };
            },
            skip () {
                return !this.workItemId;
            },
            update (data) {
                return Boolean(findNotificationsWidget(data?.workItem)?.subscribed);
            },
            error (error) {
                Sentry.captureException(error);
            }
        }
    },
    computed: {
        isLoggedIn () {
            return isLoggedIn();
        },
        // eslint-disable-next-line vue/no-unused-properties
        tracking () {
            return {
                extra: {
                    viewContext: this.viewContext
                }
            };
        },
        i18n () {
            return {
                deleteWorkItem: sprintf(s__('WorkItem|Delete %{workItemType}'), {
                    workItemType: lowercaseWorkItemType(this.workItemType)
                }),
                convertError: sprintf(s__('WorkItem|Something went wrong while promoting the %{workItemType}. Please try again.'), {
                    workItemType: lowercaseWorkItemType(this.workItemType)
                }),
                copyCreateNoteEmail: sprintf(s__('WorkItem|Copy %{workItemType} email address'), {
                    workItemType: lowercaseWorkItemType(this.workItemType)
                }),
                copyReferenceError: sprintf(s__('WorkItem|Something went wrong while copying the %{workItemType} reference. Please try again.'), {
                    workItemType: lowercaseWorkItemType(this.workItemType)
                }),
                copyCreateNoteEmailError: sprintf(s__('WorkItem|Something went wrong while copying the %{workItemType} email address. Please try again.'), {
                    workItemType: lowercaseWorkItemType(this.workItemType)
                })
            };
        },
        areYouSureDeleteMessage () {
            const message = this.hasChildren ? s__('WorkItem|Delete this %{workItemType} and release all child items? This action cannot be reversed.') : s__('WorkItem|Are you sure you want to delete the %{workItemType}? This action cannot be reversed.');
            return sprintf(message, {
                workItemType: lowercaseWorkItemType(this.workItemType)
            });
        },
        workItemTypeConfiguration () {
            return this.getWorkItemTypeConfiguration(this.workItemType);
        },
        canPromoteToObjective () {
            if (!this.canUpdateMetadata) return false;
            return this.workItemTypeConfiguration?.canPromoteToObjective;
        },
        confidentialItem () {
            return {
                text: this.confidentialItemText,
                extraAttrs: {
                    disabled: this.isParentConfidential
                }
            };
        },
        confidentialItemText () {
            return this.isConfidential ? this.$options.i18n.disableConfidentiality : this.$options.i18n.enableConfidentiality;
        },
        confidentialItemIcon () {
            return this.isConfidential ? 'eye' : 'eye-slash';
        },
        confidentialTooltip () {
            return this.isParentConfidential ? this.$options.i18n.confidentialParentTooltip : '';
        },
        lockDiscussionText () {
            return this.isDiscussionLocked ? __('Unlock discussion') : __('Lock discussion');
        },
        lockDiscussionIcon () {
            return this.isDiscussionLocked ? 'lock-open' : 'lock';
        },
        objectiveWorkItemTypeId () {
            return this.workItemTypes.find((type)=>type.name === WORK_ITEM_TYPE_NAME_OBJECTIVE).id;
        },
        currentWorkItemTypeId () {
            return this.workItemTypes.find((type)=>type.name === this.workItemType)?.id ?? '';
        },
        showDropdownTooltip () {
            return !this.isDropdownVisible ? this.$options.i18n.moreActions : '';
        },
        submitAsSpamItem () {
            const href = markAsSpamProjectIssuePath(this.fullPath, {
                id: this.workItemIid
            });
            return {
                text: __('Submit as spam'),
                href
            };
        },
        copyCreateNoteEmailItem () {
            return {
                text: this.i18n.copyCreateNoteEmail
            };
        },
        deleteItem () {
            return {
                text: this.i18n.deleteWorkItem
            };
        },
        isAuthor () {
            return this.workItemAuthorId === window.gon.current_user_id;
        },
        relatedItemData () {
            return {
                id: this.workItemId,
                reference: this.workItemReference,
                type: this.workItemType,
                webUrl: this.workItemWebUrl
            };
        },
        showChangeType () {
            if (!this.canUpdateMetadata) {
                return false;
            }
            const currentType = this.workItemTypes.find((type)=>type.name === this.workItemType);
            return currentType?.supportedConversionTypes?.length > 0;
        },
        showStateItem () {
            return this.canUpdate && !(this.workItemState === STATE_CLOSED && this.isDiscussionLocked);
        },
        showMoveButton () {
            return this.workItemTypeConfiguration?.supportsMoveAction && this.canMove;
        },
        toggleSidebarLabel () {
            return this.showSidebar ? s__('WorkItem|Hide sidebar') : s__('WorkItem|Show sidebar');
        },
        toggleSidebarKeys () {
            const modifierKey = getModifierKey();
            return keyboardShortcutsDisabled() ? null : `${modifierKey}/`;
        }
    },
    watch: {
        updateInProgress (newValue, oldValue) {
            if (oldValue && !newValue && this.updateInProgressPromise) {
                this.updateInProgressPromise.resolve();
                this.updateInProgressPromise = null;
            }
        }
    },
    methods: {
        copyToClipboard (text, message) {
            if (this.isDetailPanel) {
                // eslint-disable-next-line no-restricted-properties
                navigator.clipboard.writeText(text);
            }
            toast(message);
            this.closeDropdown();
        },
        async handleToggleWorkItemConfidentiality () {
            this.track('click_toggle_work_item_confidentiality');
            this.$emit('toggle-work-item-confidentiality', !this.isConfidential);
            await nextTick();
            if (this.updateInProgress) {
                await new Promise((resolve)=>{
                    this.updateInProgressPromise = {
                        resolve
                    };
                });
            }
            this.closeDropdown();
        },
        handleDelete () {
            this.$refs.modal.show();
            this.closeDropdown();
        },
        handleDeleteWorkItem () {
            this.track('click_delete_work_item');
            this.$emit('delete-work-item');
        },
        handleCancelDeleteWorkItem ({ trigger }) {
            if (trigger !== 'ok') {
                this.track('cancel_delete_work_item');
            }
        },
        toggleNotifications (subscribed) {
            const notificationWidget = {
                type: WIDGET_TYPE_NOTIFICATIONS,
                subscribed,
                __typename: 'WorkItemWidgetNotifications'
            };
            this.$apollo.mutate({
                mutation: updateWorkItemNotificationsMutation,
                variables: {
                    input: {
                        id: this.workItemId,
                        subscribed
                    },
                    useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                },
                optimisticResponse: {
                    workItemSubscribe: {
                        errors: [],
                        workItem: {
                            __typename: 'WorkItem',
                            id: this.workItemId,
                            ...this.glFeatures?.workItemFeaturesField ? {
                                features: {
                                    __typename: 'WorkItemFeatures',
                                    notifications: notificationWidget
                                }
                            } : {
                                widgets: [
                                    notificationWidget
                                ]
                            }
                        }
                    }
                }
            }).then(({ data })=>{
                const { errors } = data.workItemSubscribe;
                if (errors?.length) {
                    throw new Error(errors[0]);
                }
                toast(subscribed ? this.$options.i18n.notificationOn : this.$options.i18n.notificationOff);
            }).catch((error)=>{
                this.$emit('error', error.message);
                Sentry.captureException(error);
            });
        },
        throwConvertError () {
            this.$emit('error', this.i18n.convertError);
        },
        closeDropdown () {
            this.$refs.workItemsMoreActions.close();
        },
        toggleDiscussionLock () {
            this.isLockDiscussionUpdating = true;
            this.$apollo.mutate({
                mutation: updateWorkItemMutation,
                variables: {
                    input: {
                        id: this.workItemId,
                        notesWidget: {
                            discussionLocked: !this.isDiscussionLocked
                        }
                    },
                    useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                }
            }).then(({ data })=>{
                const { errors } = data.workItemUpdate;
                if (errors?.length) {
                    throw new Error(errors);
                }
                toast(this.isDiscussionLocked ? __('Discussion locked.') : __('Discussion unlocked.'));
            }).catch((error)=>{
                this.$emit('error', error.message);
                Sentry.captureException(error);
            }).finally(()=>{
                this.isLockDiscussionUpdating = false;
                this.closeDropdown();
            });
        },
        async promoteToObjective () {
            try {
                const { data: { workItemConvert: { errors } } } = await this.$apollo.mutate({
                    mutation: convertWorkItemMutation,
                    variables: {
                        input: {
                            id: this.workItemId,
                            workItemTypeId: this.objectiveWorkItemTypeId
                        },
                        useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                    }
                });
                if (errors.length > 0) {
                    this.throwConvertError();
                    return;
                }
                this.$toast.show(s__('WorkItem|Promoted to objective.'));
                this.track('promote_kr_to_objective');
            } catch (error) {
                this.throwConvertError();
                Sentry.captureException(error);
            } finally{
                this.closeDropdown();
            }
        },
        showDropdown () {
            this.isDropdownVisible = true;
            this.$emit('dropdown-show');
        },
        hideDropdown () {
            this.isDropdownVisible = false;
        },
        emitStateToggleError (error) {
            this.$emit('error', error);
        },
        handleToggleReportAbuseModal () {
            this.$emit('toggle-report-abuse-modal', true);
            this.closeDropdown();
        },
        showChangeTypeModal () {
            this.$refs.workItemsChangeTypeModal.show();
        }
    }
};
